<app-dropdown-filter [options]="options" [value]="value()" (valueChange)="value.set($event)" />
